export default {
  have_promo: 'У меня есть промокод',
  promo_code: 'Промо код',
  apply: 'Применить',
  checking: 'Проверяем',
  promo_success: 'Промокод успешно применён',
  promo_price_error: 'Промокод не применён! Проверьте его написание и для чего он должен быть применён, например, для месяца и года могут быть разные коды',
};
